import calendarStatsHTML from './calendarStatsComponent.html';

class CalendarStatsCtrl {
  byLocationSuffix = 'ByLocation';

  constructor(Authentication, PersonaCollection, LaborUISchema, Utils, sdk, $attrs) {
    'ngInject';

    Object.assign(this, { Authentication, PersonaCollection, LaborUISchema, Utils, sdk, $attrs });

    if (!('showLaborCost' in $attrs)) {
      this.showLaborCost = true;
    }

    if (!('showCountOfHours' in $attrs)) {
      this.showCountOfHours = true;
    }

    this.BY_LOCATION_SUFFIX = this.sdk('constants').BY_LOCATION_SUFFIX;
  }

  $onInit() {
    this.laborCostSubscriptionLevel =
      this.Authentication.user.orgSettings.premiumFeatures.laborCost;
  }

  get uiSchema() {
    return this.LaborUISchema.schema?.calendarUISchema?.summary;
  }

  $onChanges() {
    if (!('summariesByLocation' in this)) {
      this.summariesByLocation = {};
    }

    Object.keys(this.summary || {}).forEach((key) => {
      if (key.endsWith(this.BY_LOCATION_SUFFIX)) {
        const byLocationKey = `${key.split(this.BY_LOCATION_SUFFIX)[0]}${this.byLocationSuffix}`;
        this.summariesByLocation[byLocationKey] = Object.entries(this.summary[key]).map(
          ([locationId, value]) => ({
            location: this.PersonaCollection.personasDict[locationId],
            value,
          })
        );
      }
    });
  }

  get showHolidayNumbers() {
    return (
      this.showLaborCost &&
      this.Authentication.user.hasAccessToLaborCost &&
      this.Authentication.user.orgSettings.holidaysEnabled &&
      this.summary?.holidayHours > 0
    );
  }

  get absenceSummary() {
    const summary = {
      showTypesCount: 0,
      title: 'Absences',
      total: 0,
      showNoShows: false,
      showSickCallouts: false,
    };

    if (!this.filter.eventTypes.length || this.filter.eventTypes.includes('no_show')) {
      summary.showTypesCount++;
      summary.showNoShows = true;
      summary.total += this.summary.noShows;
      summary.title = 'No show';
    }

    if (!this.filter.eventTypes.length || this.filter.eventTypes.includes('sick_callout')) {
      summary.showTypesCount++;
      summary.showSickCallouts = true;
      summary.total += this.summary.sickCallouts;
      summary.title = 'Sick callout';
    }

    if (summary.showTypesCount > 1) {
      summary.title = 'Absences';
    }

    return summary;
  }
}

export default {
  templateUrl: calendarStatsHTML,
  controller: CalendarStatsCtrl,
  controllerAs: 'ctrl',
  transclude: true,
  bindings: {
    summary: '<',
    isMultiLocation: '<',
    showLaborCost: '<?',
    showCountOfHours: '<?',
    showLaborPercentage: '<?',
    showPlanningEvents: '<?',
    isLoading: '<?',
    filter: '<',
    options: '<',
    openAddShiftModal: '&',
  },
};
